import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { usePageTracker } from './hooks/usePageTracker';

// Pages
import Home from './pages/Home';
import TreeScreen from './pages/TreeScreen';
import TreeOperator from './pages/TreeOperator';
import GameScreen from './pages/GameScreen';
import GameLobby from './pages/GameLobby';
import GameOperator from './pages/GameOperator';
import MobileParticipant from './pages/MobileParticipant';
import RaffleScreen from './pages/RaffleScreen';
import RaffleOperator from './pages/RaffleOperator';
import StatsPage from './pages/StatsPage';

function PageTracker() {
  usePageTracker();
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Energy Tree */}
          <Route path="/tree" element={<TreeScreen />} />
          <Route path="/operator/tree" element={<TreeOperator />} />

          {/* Quiz Game */}
          <Route path="/game/lobby" element={<GameLobby />} />
          <Route path="/game/screen" element={<GameScreen />} />
          <Route path="/operator/game" element={<GameOperator />} />
          
          {/* Mobile Participant */}
          <Route path="/p/game" element={<MobileParticipant />} />
          <Route path="/p/game/:id" element={<MobileParticipant />} />

          {/* Raffle */}
          <Route path="/raffle/screen" element={<RaffleScreen />} />
          <Route path="/operator/raffle" element={<RaffleOperator />} />

          {/* Hidden Stats */}
          <Route path="/stats" element={<StatsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
